import capitalize from "./capitalize";
import doesNotContain from "./doesNotContain";

const modul = angular
    .module("Filters", [])

    // Form
    .filter("capitalize", capitalize)
    .filter("doesNotContain", doesNotContain);

export default modul.name;
